import Cookies from "universal-cookie";
import InterAxios from "../Service/InterAxios";

export const listInfopages = async () => {

    const cookies = new Cookies();
    const interAxios = new InterAxios('App', () => cookies.get('authtoken')?.token);

    return new Promise((resolve, reject) => {
        interAxios.get('/infopages', function(response) {
            resolve(response.data);
        }, function(error) {
            reject(error.response?.data);
        });
    })

}